import { Reveal } from "@/components/Reveal";
import { Chapter } from "@/components/Chapter";
import { AnswerBlock } from "@/components/AnswerBlock";
import { SERVICES } from "@/data/site";

export const Services = () => (
  <section id="servizi" data-testid="section-servizi" className="bg-paper py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter
          number="01"
          kicker="Servizi"
          title="Quali servizi di medicina del lavoro offre BPMedLav?"
        />
      </Reveal>
      <Reveal delay={0.1}>
        <AnswerBlock>
          BPMedLav offre sorveglianza sanitaria completa, accertamenti sanitari (ECG, spirometria,
          audiometria, drug test), formazione per addetti al primo soccorso secondo il DM 388/2003,
          consulenza continuativa al datore di lavoro per la conformità al D.Lgs 81/08 e
          certificazioni medico-legali INAIL e INPS. Le visite si svolgono in sede a Roma o
          direttamente in azienda.
        </AnswerBlock>
      </Reveal>

      <div className="mt-14 grid gap-px bg-ink/10 border border-ink/10 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className="bg-paper">
            <article className="h-full p-8 md:p-10 group transition-colors hover:bg-clinic-tint/60">
              <p className="font-mono text-xs text-clinic mb-5">
                {String(i + 1).padStart(2, "0")}
              </p>
              <h3 className="font-display text-2xl md:text-3xl text-ink mb-4">{s.title}</h3>
              <p className="text-sm md:text-base leading-relaxed text-ink/70 mb-6">{s.lead}</p>
              <ul className="space-y-2">
                {s.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 text-sm text-ink/80 before:content-[''] before:h-1.5 before:w-1.5 before:rotate-45 before:bg-clinic before:shrink-0"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
